import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY;

if (!supabaseUrl || !supabaseKey)
    throw new Error('Unable to connect to Supabase. Connection not defined.');

export const supabase = createClient(supabaseUrl, supabaseKey, { 
    // auth: {
    //     detectSessionInUrl: false 
    // }
});

export const auth = supabase.auth;
export const database = {
    userProfiles: { 
        getChannel: () => supabase.channel('user_profiles'), 
        table: () => supabase.from('user_profiles') 
    },
    telegramChats: {
        getChannel: () => supabase.channel('user_telegram_chats'),
        table: () => supabase.from('user_telegram_chats')
    },
    hardMatches: {
        getChannel: () => supabase.channel('hard_matches'),
        table: () => supabase.from('hard_matches')
    },
    telegramTokens: {
        table: () => supabase.from('user_telegram_tokens')
    },
    flats: {
        table: () => supabase.from('flats')
    },
    userFeedback: {
        table: () => supabase.from('user_feedback')
    },
    publicProfiles: {
        table: () => supabase.from('public_profiles')
    },
    newspaperRequests: {
        table: () => supabase.from('newspaper_requests'),
        getChannel: () => supabase.channel('newspaper_requests')
    },
    stripeCustomerSubscriptions: {
        table: () => supabase.from('stripe_customer_subscriptions'),
        getChannel: () => supabase.channel('stripe_customer_subscriptions')
    },
    views: {
    }
}
export const storage = {
    profilePictures: () => supabase.storage.from('profile_pictures')
};